// File: src/components/pages/Homepage.jsx
// Clear, sharp images without lightbox - NO MODAL ISSUES

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, ArrowRight } from 'lucide-react';
import './Homepage.css';

// Import images (adjust paths as needed)
import logo from '../../assets/logo14.png';
import studentBooking from '../../assets/StudentSlotBooking.png';
import myBookings from '../../assets/Student-MyBookings.png';
import studentSignup from '../../assets/Student-Signup.png';
import manageStudents from '../../assets/ManageStudents-ActiveStudents.png';
import manageSlots from '../../assets/ManageBookings-MySlots.png';
import manageTemplate from '../../assets/ManageTemplate.png';
import LoginButton from '../../components/LoginButton';

const Homepage = () => {
  const navigate = useNavigate();
  const [currentFeature, setCurrentFeature] = useState(0);

  const features = [
     {
          image: manageTemplate,
          title: 'Management Your Availability',
          description: 'Create and manage your availability'
        },
        {
          image: manageSlots,
          title: 'Management Bookings',
          description: 'Create and manage your booking slots'
        },
        {
          image: manageStudents,
          title: 'Manage Students',
          description: 'Instructor dashboard for student management'
        },
        {
          image: studentSignup,
          title: 'Student Signup',
          description: 'Student registration page'
        },
        {
          image: studentBooking,
          title: 'Book Your Lessons',
          description: 'Easy slot booking for students'
        },
        {
          image: myBookings,
          title: 'Manage Your Bookings',
          description: 'View all your upcoming lessons'
        }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFeature((prev) => (prev + 1) % features.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [features.length]);

  const handleLogin = () => {
    navigate('/login');
  };

  const handleSignup = () => {
    //navigate('/signup');
    navigate('/explore');
  };

  return (
    <div className="homepage-container">
      {/* Header with Auth Buttons */}
      <header className="homepage-header">
        <div className="auth-buttons">
            <LoginButton className="btn-login" />
          <button className="btn-signup" onClick={handleSignup}>
            <span>Sign Up</span>
            <ArrowRight size={18} />
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="homepage-main">
        {/* Logo Section */}
        <div className="logo-section">
          <img src={logo} alt="Booking System Logo" className="main-logo" />
          <h1 className="brand-title">Booking System</h1>
          <p className="brand-tagline">Streamline Your Driving Lessons</p>
        </div>

        {/* Feature Showcase */}
        <div className="feature-showcase">
          <div className="feature-slider">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`feature-slide ${
                  index === currentFeature ? 'active' : ''
                } ${index === currentFeature - 1 || (currentFeature === 0 && index === features.length - 1) ? 'previous' : ''}`}
              >
                <div className="image-wrapper">
             
                 <img
                    src={feature.image}
                    alt={feature.title}
                    className="feature-image"/>

                </div>
                <div className="feature-info">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Slider Indicators */}
          <div className="slider-indicators">
            {features.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentFeature ? 'active' : ''}`}
                onClick={() => setCurrentFeature(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="cta-section">
          <h2>Get Started Today</h2>
          <div className="cta-buttons">
            <button className="cta-btn primary" onClick={handleSignup}>
              Create Account
            </button>
              <LoginButton className="cta-btn secondary"/>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="homepage-footer">
        <p>&copy; 2026 Booking System. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Homepage;